import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="System contents" className="bg-transparent" data-id="element-277" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-6" data-id="element-278" data-mp="18228gsl3fjf4">
        <div className="text-center" data-id="element-279" data-mp="1c6idkrmvumta">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-280" data-mp="1c3e4pgyh32wa">
            THE 100+ AI PROMPTS FOR ELECTRICAL ENGINEERS™ SYSTEM
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-281" data-mp="24surnz3bprl4">
            📚 The 6-Volume Engineering AI Toolkit
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-plum/65 sm:text-base" data-id="element-282" data-mp="1vtg0syj8vf03">
            A visual, practical collection of more than 100 prompts organized into six specialized volumes.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-283" data-mp="keaulkjwmybq">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-grape-deep" data-id="element-284" data-mp="kby9iyiuo7ug">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-285" data-mp="21hwmjvonxnf">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-grape/15 bg-white p-5" data-id="element-286" data-mp="3t6q9ifur9a2j" data-mpi={i}>
              <div className="flex items-start gap-3" data-id="element-287" data-mp="ktiyzw7o261l">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-plum font-display text-lg font-black text-white" data-id="element-288" data-mp="fteii66rdbbd">
                  {String(t.n).padStart(2, '0')}
                </span>
                <div className="min-w-0" data-id="element-289" data-mp="ps41k2ae51t7">
                  <p className="text-[11px] font-bold uppercase tracking-wide text-grape" data-id="element-290" data-mp="wtr6f87a3l3h">{t.area}</p>
                  <h3 className="mt-0.5 text-sm font-bold leading-tight text-plum" data-id="element-291" data-mp="11skiqxatx622">{t.title}</h3>
                </div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-292" data-mp="16qvpgz5tv0g2">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-293" data-mp="1bjydysvqzjpe">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-294" data-mp="1fjfjtnf36iv3">
            ✅ Every Volume Includes:
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-295" data-mp="1klekgpjfz1oc">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-296" data-mp="1pj6bzig6cls0">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-297" data-mp="1ugzkii4y9rvg" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}